import React from "react";
import "./contact.css";

import { BsLinkedin, BsWhatsapp } from "react-icons/bs";
import { MdOutlineEmail } from "react-icons/md";
/* EMAILJS */
import emailjs from "emailjs-com";
import { useRef } from "react";
/* SWEETALERT */
import Swal from "sweetalert2";
/* i18n */
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_qglvlbg",
        "template_5n100hu",
        form.current,
        "DpPQLkfSOFzx2lPgu"
      )
      .then(
        (result) => {
          Swal.fire({
            title: "Send!",
            text: "Message sent successfully!",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "green",
            // timer: "3000",
          });
        },
        (error) => {
          Swal.fire({
            title: "Error!",
            text: error.message,
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#d33",
            // timer: "3000",
          });
        }
      );
    e.target.reset();
  };
  return (
    <section id="contact">
      <h4>{t("contact.subtitle")}</h4>
      <h2>{t("contact.title")}</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon" />
            <h5>Email</h5>
            <h5>millanendersondev@gmail.com</h5>
            <a
              href="mailto:millanendersondev@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              {t("contact.form.send")}
            </a>
          </article>
          <article className="contact__option">
            <BsLinkedin className="contact__option-icon" />
            <h5>LinkedIn</h5>
            <h5>Enderson Millan</h5>
            <a
              href="https://www.linkedin.com/in/enderson-millan"
              target="_blank"
              rel="noreferrer"
            >
              {t("contact.form.send")}
            </a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon" />
            <h5>WhatsApp</h5>
            <h5>(+55)47-99947-7229</h5>
            <a
              href="https://web.whatsapp.com/send?phone=5547999477229"
              target="_blank"
              rel="noreferrer"
            >
              {t("contact.form.send")}
            </a>
          </article>
        </div>
        {/* END CONTACT OPTIONS */}
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder={t("contact.form.name")}
            required
          />
          <input
            type="email"
            name="email"
            placeholder={t("contact.form.email")}
            required
          />
          <textarea
            name="message"
            rows="7"
            placeholder={t("contact.form.message")}
            required
          ></textarea>
          <button type="submit" className="submit__button">
            <h4 className="">{t("contact.form.send")}</h4>
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
